import {filterDOMProps as $3GX9J$filterDOMProps} from "@react-aria/utils";
import $3GX9J$react, {forwardRef as $3GX9J$forwardRef} from "react";
import {useSlotProps as $3GX9J$useSlotProps, useStyleProps as $3GX9J$useStyleProps, useDOMRef as $3GX9J$useDOMRef} from "@react-spectrum/utils";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $cd449e8defa988f0$var$Text(props, ref) {
    props = (0, $3GX9J$useSlotProps)(props, "text");
    let { children: children, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $3GX9J$useStyleProps)(otherProps);
    let domRef = (0, $3GX9J$useDOMRef)(ref);
    return /*#__PURE__*/ (0, $3GX9J$react).createElement("span", {
        ...(0, $3GX9J$filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, children);
}
/**
 * Text represents text with no specific semantic meaning.
 */ const $cd449e8defa988f0$export$5f1af8db9871e1d6 = /*#__PURE__*/ (0, $3GX9J$forwardRef)($cd449e8defa988f0$var$Text);


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $c382fceb69609a50$var$Heading(props, ref) {
    props = (0, $3GX9J$useSlotProps)(props, "heading");
    let { children: children, level: level = 3, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $3GX9J$useStyleProps)(otherProps);
    let domRef = (0, $3GX9J$useDOMRef)(ref);
    let HeadingTag = `h${level}`;
    return /*#__PURE__*/ (0, $3GX9J$react).createElement(HeadingTag, {
        ...(0, $3GX9J$filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, children);
}
/**
 * Heading is used to create various levels of typographic hierarchies.
 */ const $c382fceb69609a50$export$a8a3e93435678ff9 = /*#__PURE__*/ (0, $3GX9J$forwardRef)($c382fceb69609a50$var$Heading);


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $a42b6b1607b36926$var$Keyboard(props, ref) {
    props = (0, $3GX9J$useSlotProps)(props, "keyboard");
    let { children: children, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $3GX9J$useStyleProps)(otherProps);
    let domRef = (0, $3GX9J$useDOMRef)(ref);
    return /*#__PURE__*/ (0, $3GX9J$react).createElement("kbd", {
        ...(0, $3GX9J$filterDOMProps)(otherProps),
        ...styleProps,
        ref: domRef
    }, children);
}
/**
 * Keyboard represents text that specifies a keyboard command.
 */ const $a42b6b1607b36926$export$16e4d70cc375e707 = /*#__PURE__*/ (0, $3GX9J$forwardRef)($a42b6b1607b36926$var$Keyboard);




export {$cd449e8defa988f0$export$5f1af8db9871e1d6 as Text, $c382fceb69609a50$export$a8a3e93435678ff9 as Heading, $a42b6b1607b36926$export$16e4d70cc375e707 as Keyboard};
//# sourceMappingURL=module.js.map
